import { statisticsStyles } from '@totem/components/ui_components/widgets/statistic/IBStatistic';

export const ticketStyles = {
  colors: {
    positive: statisticsStyles.info.color, //'#144d6f',
    negative: statisticsStyles.warning.color, //'#E15B27',
  },
};
